import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '../../ui/components/web/Dialog';
import ProfileTab from '../../../settings/components/web/ProfileTab';
import { translate } from '../../i18n/functions';
import { submitProfileTab } from '../../../settings/actions.web';
import { getProfileTabProps } from '../../../settings/functions.any';
class ProfileDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabState: { ...props.profileTabProps }
        };
        this._onSubmitValue = this._onSubmitValue.bind(this);
        this._onChange = this._onChange.bind(this);
    }
    _onSubmitValue() {
        ;
        const { dispatch } = this.props;
        dispatch(submitProfileTab(this.state.tabState));
    }
    _onChange(tabStateUpdate) {
        this.setState(prevState => ({
            tabState: {
                ...prevState.tabState,
                ...tabStateUpdate // Spread the update object into the existing tabState
            }
        }));
    }
    render() {
        const { t, profileTabProps } = this.props;
        profileTabProps.onChange = this._onChange;
        return (React.createElement(Dialog, { disableAutoHideOnSubmit: false, ok: {
                translationKey: 'dialog.Ok'
            }, onSubmit: this._onSubmitValue, titleKey: 'profile.title' }, React.createElement(ProfileTab, { ...profileTabProps })));
    }
}
function _mapStateToProps(state, ownProps) {
    const profileTabPropsFromState = getProfileTabProps(state);
    return {
        profileTabProps: {
            ...ownProps.profileTabProps,
            ...profileTabPropsFromState
        }
    };
}
;
export default translate(connect(_mapStateToProps)(ProfileDialog));
